import { useEffect, useState } from 'react';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactComponent as IconSlideLeft } from 'asserts/icons/ic_chevron_left.svg';
import { ReactComponent as IconSlideRight } from 'asserts/icons/ic_chevron_right.svg';

interface Props {
  images: { id: number; src: string; alt: string }[];
}
const SliderSlick = ({ images }: Props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(0);
  }, [images]);

  const leftNext = () => {
    const labels = document.querySelectorAll('#slider label');
    const nextIndex = selectedIndex < 1 ? labels.length - 1 : selectedIndex - 1;
    setSelectedIndex(nextIndex);
  };

  const rightNext = () => {
    const labels = document.querySelectorAll('#slider label');
    const nextIndex = selectedIndex === labels.length - 1 ? 0 : selectedIndex + 1;
    setSelectedIndex(nextIndex);
  };
  const check = (index: number) => setSelectedIndex(index);

  return (
    <SliderSlickWrapper>
      <Btn className="left" onClick={leftNext}>
        <IconSlideLeft />
      </Btn>
      <Btn className="right" onClick={rightNext}>
        <IconSlideRight />
      </Btn>
      <section
        id="slider"
        className="w-16 h-20 inline-flex items-center justify-center mb-5 flex-shrink-0"
      >
        <input
          type="radio"
          name="slider"
          id="s1"
          checked={selectedIndex === 0}
          onClick={() => check(0)}
          readOnly
        />
        <input
          type="radio"
          name="slider"
          id="s2"
          checked={selectedIndex === 1}
          onClick={() => check(1)}
          readOnly
        />
        <input
          type="radio"
          name="slider"
          id="s3"
          checked={selectedIndex === 2}
          onClick={() => check(2)}
          readOnly
        />
        {images &&
          images?.map((img: any, index: number) => (
            <label key={index} htmlFor={`s${index + 1}`} id={`slide${index + 1}`}>
              <img
                className="fea"
                src={img.src}
                height="100%"
                width="100%"
                alt="슬라이드 이미지"
                loading="lazy"
              />
            </label>
          ))}
      </section>
    </SliderSlickWrapper>
  );
};

export default SliderSlick;

const SliderSlickWrapper = styled.div`
  position: relative;
  width: 1440px;
  margin: 0 auto;

  [type='radio'] {
    display: none;
  }

  #slider {
    width: calc(434px * 2);
    height: 612px;
    margin: 0 auto;
    position: relative;
    perspective: 1000px;
    transform-style: preserve-3d;
  }

  #slider label {
    margin: auto;
    background-color: aliceblue;
    width: 434px;
    height: 612px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    right: 0;
    cursor: pointer;
    transition: transform 0.4s ease;
  }

  #s1:checked ~ #slide3,
  #s2:checked ~ #slide1,
  #s3:checked ~ #slide2 {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3), 0 2px 2px 0 rgba(0, 0, 0, 0.2);
    transform: translate3d(-121%, 0, -200px);
    opacity: 0.3;
  }

  #s1:checked ~ #slide1,
  #s2:checked ~ #slide2,
  #s3:checked ~ #slide3 {
    box-shadow: 0 13px 25px 0 rgba(0, 0, 0, 0.3), 0 11px 7px 0 rgba(0, 0, 0, 0.19);
    transform: translate3d(0, 0, 0);
  }

  #s1:checked ~ #slide2,
  #s2:checked ~ #slide3,
  #s3:checked ~ #slide1 {
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3), 0 2px 2px 0 rgba(0, 0, 0, 0.2);
    transform: translate3d(121%, 0, -200px);
    opacity: 0.3;
  }
`;

const Btn = styled.button`
  background: ${color.gradientType1};
  width: 52px;
  height: 52px;
  border-radius: 50%;
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 24px;
    height: 24px;
    margin: 0 atuo;
    fill: ${color.white};
  }
  &.left {
    left: 425px;
  }
  &.right {
    right: 425px;
  }
`;
